<div class="horizontal-grouped-bar-chart-wrapper">
  <div #horizontalGroupedBarChart class="chart-container"></div>
  @if (showLegend()) {
    <div class="list-button">
      <ul class="graph-point">
        @for (item of legendItems(); track item.name) {
          <li>
            <div class="legend-color" [style.backgroundColor]="item.color"></div>{{ item.name }}
          </li>
        }
      </ul>
    </div>
  }
</div>